const validToken = token => typeof token === 'string' && /^[A-Za-z0-9_-]{43}$/.test(token);
const storageKey = id => `jlastore:private-spin:${id}`;
const memoryFallback = new Map();

export function rememberSpinToken(id, token) {
  if (!id || !validToken(token)) return;
  try { window.sessionStorage.setItem(storageKey(id), token); } catch (_) { memoryFallback.set(id, token); }
  // Payment providers may return in a new tab. Keep only this order capability,
  // not a login, for 30 days on the same browser; never send it to a provider.
  try { window.localStorage.setItem(storageKey(id), JSON.stringify({ token, expires: Date.now() + 30 * 86400000 })); } catch (_) {}
}

export function getSpinToken(id, hash = '') {
  const fromLink = new URLSearchParams(hash.replace(/^#/, '')).get('key');
  if (validToken(fromLink)) return fromLink;
  try { const token = window.sessionStorage.getItem(storageKey(id)); if (validToken(token)) return token; } catch (_) {}
  try {
    const saved = JSON.parse(window.localStorage.getItem(storageKey(id)) || 'null');
    if (saved?.expires > Date.now() && validToken(saved.token)) return saved.token;
  } catch (_) {}
  return memoryFallback.get(id) || '';
}

export const spinAccessHeaders = token => validToken(token) ? { 'X-Lucky-Box-Token': token } : {};
export const privateSpinPath = (id, token) => `/spin/${encodeURIComponent(id)}${validToken(token) ? `#key=${token}` : ''}`;

// Run before analytics/router mount: private capabilities must not enter page-view URLs.
export function capturePrivateSpinLink() {
  // The document bootstrap runs before analytics; retain its storage-blocked fallback.
  const early = window.__jlastorePrivateSpinFallback;
  if (early?.id && validToken(early.token)) memoryFallback.set(early.id, early.token);
  delete window.__jlastorePrivateSpinFallback;
  const match = window.location.pathname.match(/^\/(?:spin|invoice|lucky-box)\/([A-Za-z][A-Za-z0-9_-]{6,119})\/?$/);
  if (!match) return;
  const token = getSpinToken(match[1], window.location.hash);
  if (!token) return;
  rememberSpinToken(match[1], token);
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
}
